<template>
        <div class="profile-info-block mb-3">
            <div class="profile-edit-block">
              <h2 class="rg-title">パスワード</h2>
                <EditButton
                  title="編集"
                  @click="showModal"
                />
            </div>
           <div class="profile-info">
            <p class="pwd">********</p>
           </div>
          <b-modal
            id="modal1"
            ref="modal"
            hide-footer
            size="lg"
            :no-close-on-esc="true"
            :no-close-on-backdrop="true"
            @shown="addEventListeners"
            @hide="removeEventListeners"
          >
            <template #modal-header>
              <!-- Emulate built in modal header close button action -->
              <!-- <img
                src="../assets/close.png"
                v-on:click.prevent="hideModal"
                style="cursor:pointer;margin-top:5px"
              /> -->
              <h5 class="sharingTitle" style="margin-top:5px">
                パスワード
              </h5>
              <CancelModal @click="cancel" />
              <!-- <button
                data-v-bf1681ae=""
                title="保存"
                class="btn btn-secondary rounded btn-sm font-16 editBtn"
                @click="reset"
              >
                保存
              </button> -->
            </template>
            <form v-on:submit.prevent="reset">
              <div class="form-wrap mb-0">
                <div class="form-sep-block">
                  <div class="item-form-block">
                    <div class="form-group row">
                      <div class="col-12 mb-2">
                        <label class="cstm-label">
                          <span class="span-badge mr-2">必須</span>
                          現在のパスワード
                        </label>
                        <div class="input-group custom-group">
                          <input
                            :type="inputTypeOld"
                            class="form-control is-valid"
                            v-bind:class="{
                              'is-invalid': hasError('old_password'),
                            }"
                            name="old_password"
                            v-model="old_password"
                            tabindex="1"
                            v-validate="'required|doubleByte|min:8'"
                            data-vv-as="現在のパスワード"
                          />
                          <button
                            class="btn-eye"
                            type="button"
                            v-on:click.prevent="showPassword('old')"
                          >
                            <i :class="eyeIconOld" aria-hidden="true"></i>
                          </button>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('old_password')"
                          >
                            {{ getErrorMessage("old_password") }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <label class="cstm-label full">
                           <span class="span-badge mr-2">必須</span>
                          新規パスワード
                        </label>
                        <!-- <label class="cstm-label mobile"
                          >新しいパスワード</label
                        > -->
                        <div class="input-group custom-group">
                          <input
                            :type="inputType"
                            class="form-control is-valid"
                            v-bind:class="{
                              'is-invalid': hasError('password'),
                            }"
                            name="new_password"
                            v-model="password"
                            tabindex="2"
                            v-validate="'required|doubleByte|min:8'"
                            ref="password"
                            data-vv-as="パスワード"
                            placeholder="8文字以上入力してください"
                          />
                          <button
                            class="btn-eye"
                            type="button"
                            v-on:click.prevent="showPassword('new')"
                          >
                            <i :class="eyeIcon" aria-hidden="true"></i>
                          </button>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('password')"
                          >
                           {{ getErrorMessage("password") }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <label class="cstm-label"
                          > <span class="span-badge mr-2">必須</span>
                          新規パスワード（確認用）
                        </label
                        >
                        <div class="input-group custom-group">
                          <input
                            :type="inputTypeConfirmation"
                            class="form-control is-valid"
                            v-bind:class="{
                              'is-invalid': hasError('password_confirmation'),
                            }"
                            name="password_confirmation"
                            v-model="password_confirmation"
                            tabindex="3"
                            v-validate="'required|confirmed:password'"
                            data-vv-as="新規パスワード（確認用）"
                            placeholder="8文字以上入力してください"
                          />
                          <button
                            class="btn-eye"
                            type="button"
                            v-on:click.prevent="showPassword('conf')"
                          >
                            <i :class="eyeIconConf" aria-hidden="true"></i>
                          </button>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('password_confirmation')"
                          >
                            {{ getErrorMessage("password_confirmation") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button
                      data-v-bf1681ae=""
                      title="保存"
                      class="btn btn-secondary rounded font-16 profile-edit-btn"
                      @click.prevent="reset"
                    >
                      この内容で保存する
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </b-modal>
        </div>
        <!-- ends main-area -->
    <!-- ends user-content -->
  <!-- ends user-wrapper -->
</template>
<script>
import swal from "sweetalert";
import Api from "../config/api";
import logo from "../assets/Group300.png";
import modalEventListener from "../mixins/modalEventListener";
import CancelModal from "./CancelModal.vue";
import EditButton from './EditButton.vue';

export default {
  mixins: [modalEventListener],
  components: { CancelModal, EditButton },
  data() {
    return {
      server_errors: {},
      old_password: "",
      password: "",
      password_confirmation: "",
      disable: false,
      eyeIcon: "fa-solid fa-eye-slash",
      eyeIconOld: "fa-solid fa-eye-slash",
      eyeIconConf: "fa-solid fa-eye-slash",
      inputType: "password",
      inputTypeOld: "password",
      inputTypeConfirmation: "password",
    };
  },
  methods: {
    hasError(field) {
      return (
        field in this.server_errors || this.errors.first(field) !== undefined
      );
    },
    getErrorMessage(field) {
      if (this.errors.first(field) !== undefined) {
        return this.errors.first(field);
      } else if (field in this.server_errors) {
        return this.server_errors[field].msg;
      }
      return null;
    },
    showModal() {
      this.$refs.modal.show();
    },
    //hideModal
    cancel() {
      this.clearForm();
      this.$refs.modal.hide();
    },
    showPassword(field) {
      if (field === "old") {
        if (this.inputTypeOld === "password") {
          this.inputTypeOld = "text";
          this.eyeIconOld = "fa-solid fa-eye";
        } else {
          this.inputTypeOld = "password";
          this.eyeIconOld = "fa-solid fa-eye-slash";
        }
      } else if (field == "new") {
        if (this.inputType === "password") {
          this.inputType = "text";
          this.eyeIcon = "fa-solid fa-eye";
        } else {
          this.inputType = "password";
          this.eyeIcon = "fa-solid fa-eye-slash";
        }
      } else if (field == "conf") {
        if (this.inputTypeConfirmation === "password") {
          this.inputTypeConfirmation = "text";
          this.eyeIconConf = "fa-solid fa-eye";
        } else {
          this.inputTypeConfirmation = "password";
          this.eyeIconConf = "fa-solid fa-eye-slash";
        }
      }
    },
    clearForm() {
      this.password = "";
      this.old_password = "";
      this.password_confirmation = "";
    },
    async reset() {
      this.disable = true;
      try {
        const check = await this.$validator.validate();
        if (check) {
          const content1 = document.createElement("span");
          content1.innerHTML =
            '<p style="font-weight:bold">パスワードを更新しますか？</p>';
          const resp = await swal({
            // title:
            //   "メールアドレスを変更します。続行する場合はOKをクリックしてください。",
            icon: "warning",
            content: content1,
            className: "custom-swal5",
            closeOnClickOutside: false,
            buttons: {
              cancel: "キャンセル",
              ok: "更新する",
              // ok: {
              //   text: "OK",
              //   value: true,
              //   visible: true,
              //   closeModal: true,
              //   className: "custom-red",
              // },
            },
          });
          if (resp) {
            const token = await this.$auth.getToken();
            const res = await this.axios({
              method: "post",
              data: {
                old_password: this.old_password,
                password: this.password,
                password_confirmation: this.password_confirmation,
              },
              url: Api.url(Api.endpoints.changePassword),
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            this.$refs.modal.hide();
            const content = document.createElement("span");
            content.innerHTML =
              '<p style="font-weight:bold">パスワードを更新しました。</p>';
            await swal({
              title: "",
              content,
              className: "custom-swal4",
              // icon: logo,
              buttons: {
                ok: "OK",
              },
            });
            this.clearForm();
          }
          // this.clearForm();
          // this.$router.push({ name: "home" });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 422) {
          this.server_errors = error.response.data;
        } else if (error.response.status === 503) {
          this.$router.push({ name: "Logout" });
        } else {
          await swal({
            text: error.response.data.message,
            icon: "warning",
          });
          this.$router.push({ name: "home" });
        }
      }
      this.disable = false;
    },
  },
};
</script>
<style scoped>
.sml-container {
  max-width: 820px;
}
h3 {
  font-size: 21px;
  font-weight: 900;
  margin-bottom: 27px;
}
>>> .sharingTitle {
  margin-top: 5px;
  color: black !important;
  font-weight: 600;
}


.pwd {
  color: #787878;
  font-weight: 600;
}
.btn {
  border-radius: 8px;
}
.btn-eye {
  /* margin-top: 10px; */
  margin-right: 10px;
}
.item-form-block .form-control {
  min-height: 40px;
}
.cancel {
  width: 49%;
  height: 48px;
  border: none;
  padding: 12px 20px;
}
.submit {
  width: 49%;
  height: 48px;
  padding: 12px 20px;
  border: none;
  margin-left: 12px !important;
}
.is-valid {
  background-image: none;
}
.is-invalid {
  background-image: none;
}
.swal-overlay .swal-overlay--show-modal .swal-modal.swal-footer {
  text-align: center !important;
}
.main-area {
  border: 0.5px solid #e6e6e6;
  border-radius: none !important;
}
.mobile {
  display: none;
}
.edit-block {
  right: 0px;
  top: 50px;
}
@media (max-width: 767px) {
  .editBtn {
    width: 100px !important;
    height: 50px !important;
  }
}
@media (max-width: 550px) {
  .main-area {
    width: 100%;
  }
  .cancel {
    width: 48%;
  }
  .submit {
    width: 48%;
    margin-left: 12px !important;
  }
  .mobile {
    display: block;
  }
  /* .full {
    display: none;
  } */
}
@media (max-width: 320px) {
  .cancel {
    width: 48%;
  }
  .submit {
    width: 48%;
    margin-left: 5px !important;
  }
}
</style>
